<template>
  <section class="services">
    <div class="container">
      <h2 v-scroll-reveal>{{ $t('services.title') }}</h2>
      <div class="services-grid">
        <article class="service-card" v-for="card in cards" :key="card.key">
          <span class="focus-badge">{{ $t(`services.${card.key}.focus`) }}</span>
          <h3>{{ $t(`services.${card.key}.title`) }}</h3>
          <p>{{ $t(`services.${card.key}.description`) }}</p>
          <ul class="feature-list">
            <li v-for="(feature, i) in $tm(`services.${card.key}.features`)" :key="i">{{ $rt(feature) }}</li>
          </ul>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup>
const cards = [
  { key: 'cardA' },
  { key: 'cardB' },
  { key: 'cardC' },
  { key: 'cardD' }
]
</script>

<style scoped>
.services {
  padding: 80px 20px;
  background-color: var(--white);
}
.container {
  max-width: 1200px;
  margin: 0 auto;
}
h2 {
  text-align: center;
  margin-bottom: 50px;
  font-size: 2.5rem;
  color: var(--text-color);
}
.services-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}
.service-card {
  padding: 30px;
  border: 1px solid var(--gray-light);
  border-radius: 10px;
  background-color: var(--gray-light);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}
.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.05);
  border-color: var(--accent-color);
}
.focus-badge {
  display: inline-block;
  align-self: flex-start;
  background-color: var(--primary-color);
  color: var(--white);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 4px 12px;
  border-radius: 20px;
  margin-bottom: 16px;
}
h3 {
  margin-bottom: 16px;
  color: var(--primary-color);
  font-size: 1.3rem;
}
p {
  line-height: 1.6;
  color: var(--text-color);
  opacity: 0.8;
}
.feature-list {
  margin-top: 12px;
  padding-left: 20px;
  line-height: 1.8;
  color: var(--text-color);
  opacity: 0.8;
}
.feature-list li {
  margin-bottom: 4px;
}
@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>
